<template>
    <el-container direction="vertical" class="card" v-loading="loading">
        <el-row class="card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка задачи
                </div>
                <div class="employer-id grey">
                    ID {{ task.id }}
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="save">
                    {{ saveBtnText }}
                </span>
                <span class="action-title action-close" @click="close">
                    Отменить
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start" class="card-general ml16">
                <el-form :model="task" label-position="top">
                    <el-row>
                        <el-col :span="24" justify="start">
                            <div class="input-label">
                                Заголовок
                            </div>
                            <div :class="{ 'error-input': errors.title }">
                                <el-input v-model="task.title" size="mini" autocomplete="off" />
                                <div class="error" v-if="errors.title">
                                    {{ errors.title[0] }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew">
                        <el-col :span="24" :class="{ 'error-input': errors.status_id }">
                            <div class="input-label">
                                Статус
                            </div>
                            <el-select v-model="task.status_id" placeholder="" size="mini">
                                <el-option
                                    v-for="taskStatus in taskStatuses"
                                    :key="taskStatus.id"
                                    :label="taskStatus.name"
                                    :value="taskStatus.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.status_id">
                                {{ errors.status_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.priority }">
                            <div class="input-label">
                                Приоритет
                            </div>
                            <el-select v-model="task.priority" placeholder="" size="mini">
                                <el-option
                                    v-for="taskPriority in taskPriorityList"
                                    :key="taskPriority.id"
                                    :label="taskPriority.name"
                                    :value="taskPriority.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.priority">
                                {{ errors.priority[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew">
                        <el-col :span="24">
                            <div class="input-label">
                                Дата создания
                            </div>
                            <div>
                                {{ task.created_at }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" :class="{ 'error-input': errors.planned }">
                            <div class="input-label">
                                Срок
                            </div>
                            <template>
                                <div class="block date-picker">
                                    <el-date-picker
                                        v-model="task.planned_date"
                                        type="date"
                                        placeholder="дата"
                                        clearable
                                        format="dd.MM.yyyy"
                                        value-format="dd.MM.yyyy"
                                        size="mini"
                                        class="w100"
                                        :picker-options="pickerOptions"
                                    />
                                </div>
                            </template>
                            <div class="error" v-if="errors.planned">
                                {{ errors.planned[0] }}
                            </div>
                        </el-col>
                        <el-col :span="12" :class="{ 'error-input': errors.planned }">
                            <div class="input-label">
                                Время
                            </div>
                            <el-select v-model="task.planned_time" placeholder="" size="mini">
                                <el-option
                                    v-for="item in defaultTimeList"
                                    :key="item"
                                    :value="item"
                                />
                            </el-select>
                            <div class="error" v-if="errors.priority">
                                {{ errors.priority[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew">
                        <el-col :span="24">
                            <div class="input-label">
                                Сделка или лид
                            </div>
                            <template v-if="issetRelatedEntity">
                                <div class="link" @click="goRelatedEntity()">
                                    {{ task.related_entity_id }}
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew">
                        <el-col :span="24">
                            <div class="input-label">
                                Постановщик
                            </div>
                            <div>
                                {{ createdUserName }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" :class="{ 'error-input': errors.assigned_user_id }">
                            <div class="input-label">
                                Исполнитель
                            </div>
                            <el-select
                                v-model="task.assigned_user_id"
                                autocomplete
                                filterable
                                clearable
                                size="mini"
                                placeholder="Введите имя исполнителя"
                            >
                                <el-option
                                    v-for="employer in employerOptions"
                                    :key="employer.id"
                                    :label="employer.name"
                                    :value="employer.id"
                                />
                            </el-select>
                            <div class="error" v-if="errors.assigned_user_id">
                                {{ errors.assigned_user_id[0] }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row v-if="!isNew">
                        <el-col :span="24">
                            <div class="input-label">
                                Дата завершения
                            </div>
                            <div>
                                {{ task.finished }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="input-label" style="display: inline-block">
                                Файлы
                            </div>
                            <el-upload
                                class="task-card-upload"
                                action=""
                                :auto-upload="false"
                                :on-change="handleChange"
                                :on-exceed="handleExceed"
                                :limit="10"
                                :file-list="uploadFileList"
                                :show-file-list="false"
                                multiple
                                accept="*"
                            >
                                <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                            </el-upload>
                            <div class="task-card-files">
                                <el-tag
                                    v-for="file in uploadFileList"
                                    :key="file.name"
                                    closable
                                    type=""
                                    @close="handleClose(file)"
                                    class="pointer"
                                    size="mini"
                                    :disable-transitions="true"
                                >
                                    {{ file.name }}
                                </el-tag>
                                <div class="field-error" v-if="errors.place_photo" v-text="errors.place_photo[0]"></div>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </el-col>
            <el-col :span="16" class="card-comment" :class="{ 'error-input': errors.comment }">
                <el-row>
                    <el-col>
                        <div class="input-label">
                            Новый комментарий
                        </div>
                        <el-input
                            size="mini"
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 4}"
                            placeholder=""
                            v-model="task.new_comment"
                        />
                        <div class="error" v-if="errors.new_comment">
                            {{ errors.new_comment[0] }}
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <div class="input-label">
                            Комментарии
                        </div>
                        <scrolly class="task-comments fnt-16" v-if="task.commentaries">
                            <scrolly-viewport>
                                <div
                                    v-for="commentDate in Object.keys(task.commentaries)"
                                    :key="commentDate"
                                    class="day"
                                >
                                    <div class="title-date">
                                        {{ getCommentDate(commentDate) }}
                                    </div>
                                    <div
                                        v-for="comment in task.commentaries[commentDate]"
                                        :key="comment.id"
                                    >
                                        <div class="comment">
                                            <span class="name">
                                                {{ comment.employer ? comment.employer.full_name : 'неизвестен' }}
                                            </span>
                                            <span class="time">
                                                {{ comment.created_time }}
                                            </span>
                                        </div>
                                        <div class="text" v-html="prepareText(comment.text)">
                                        </div>
                                    </div>
                                </div>
                            </scrolly-viewport>
                            <scrolly-bar axis="y" />
                        </scrolly>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';
import moment from 'moment';
import { formatText } from '@/common/utilities';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import '@/assets/styles/card.scss';

library.add(faCheck, faPaperclip);

export default {
    name: 'TasksCardEdit',
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        entityId: {
            type: [String, Number],
            default: 0
        },
        entityType: {
            type: String,
            default: 'lead'
        }
    },
    components: {
        Scrolly,
        ScrollyViewport,
        ScrollyBar
    },
    data() {
        return {
            task: {
                id: null,
                priority: localReferences.taskPriorities.middle,
                title: null,
                planned: null,
                planned_date: null,
                planned_time: '9:00',
                status_id: null,
                related_entity_type: null,
                related_entity_id: null,
                created_user_id: null,
                assigned_user_id: null,
                new_comment: '',
                commentaries: {},
                created_user: {
                    full_name: null
                },
                assigned_user: {
                    full_name: null
                },
                files: []
            },
            loading: true,
            errors: {},
            uploadFileList: [],
            pickerOptions,
            today: moment().format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'day').format('YYYY-MM-DD')
        };
    },
    computed: {
        employerOptions() {
            return this.$store.state.references.employers.filter(item => item.date_fired === null);
        },
        taskStatuses() {
            return this.$store.state.references.taskStatuses;
        },
        taskPriorityList() {
            return localReferences.taskPrioritiesList;
        },
        defaultTimeList() {
            const start = 9;
            const end = 19;
            const result = [];
            for (let index = start; index <= end; index++) {
                result.push(index + ':00');
            }
            return result;
        },
        createdUserName() {
            return this.task.created_user && this.task.created_user.full_name ? this.task.created_user.full_name : '';
        },
        isNew() {
            return +this.id === 0;
        },
        saveBtnText() {
            return +this.id === 0 ? ' Создать ' : 'Применить';
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const intersection = Object.keys(roles).filter(x => this.approvedRoles.includes(x));

            return intersection.length > 0;
        },
        issetRelatedEntity() {
            return this.task.related_entity_id > 0;
        },
        approvedRoles() {
            return this.$store.getters['references/rolesBySectionTask'];
        }
    },
    mounted() {
        moment.locale('ru');
    },
    methods: {
        handleChange(file, fileList) {
            this.uploadFileList = fileList;
            this.task.files = [...this.uploadFileList];
        },
        handleClose(tag) {
            this.uploadFileList.splice(this.uploadFileList.indexOf(tag), 1);
            this.task.files = [...this.uploadFileList];
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        close() {
            if (this.isNew) {
                this.$router.go(-1);
            } else {
                this.$router.push({ name: 'task-card', params: { id: '' + this.id } });
            }
        },
        goRelatedEntity() {
            if (this.task.related_entity_type === 'lead') {
                this.$router.push({ name: 'lead-card', params: { id: this.task.related_entity_id } });
            } else if (this.task.related_entity_type === 'deal') {
                this.$router.push({ name: 'deal-card', params: { id: this.task.related_entity_id } });
            }
        },
        prepareFormData(isCreate = false) {
            const formData = new FormData();
            formData.append('status_id', this.task.status_id);
            formData.append('priority', this.task.priority);
            formData.append('title', this.task.title);
            if (this.task.new_comment && this.task.new_comment.length) {
                formData.append('new_comment', this.task.new_comment);
            }
            formData.append('assigned_user_id', this.task.assigned_user_id);
            this.task.planned = this.task.planned_date ? this.task.planned_date + ' ' + this.task.planned_time : null;
            formData.append('planned', this.task.planned);
            formData.set('files', JSON.stringify(this.task.files));
            this.task.files.forEach(file => {
                if (file.raw) {
                    formData.append('files' + file.uid, file.raw, file.raw.name);
                }
            });
            if (!isCreate) {
                formData.append('_method', 'PUT');
            }
            return formData;
        },
        actionAfterSave(data) {
            this.$router.push({ name: 'task-card', params: { id: '' + data.id } });
        },
        actionAfterSaveError(data) {
            this.$router.go(-1);
        },
        async save() {
            this.loading = true;
            const action = this.isNew ? 'createTask' : 'updateTask';
            try {
                const response = await this.$store.dispatch('tasks/' + action, {
                    id: this.id,
                    data: this.prepareFormData(this.isNew)
                });
                this.actionAfterSave({ id: '' + response.data.data.id });
            } catch (error) {
                let message = 'Произошла ошибка: ';
                if (error.response) {
                    if (error.response.status === 422) {
                        const errorsList = Object.keys(error.response.data.errors).map(item => error.response.data.errors[item][0]);
                        this.errors = error.response.data.errors;
                        message += 'неправильно заполнены поля: <br>• ' + errorsList.join('<br>• ');
                    } else {
                        message += error.response.data.error;
                    }
                }
                if (error.response.status === 403) {
                    this.actionAfterSaveError();
                }
            } finally {
                this.loading = false;
            }
        },
        async getTask() {
            try {
                const response = await this.$store.dispatch('tasks/getTask', this.id);
                const dataArray = response.data.data;
                dataArray.planned_date = null;
                dataArray.planned_time = null;
                if (dataArray.planned && dataArray.planned.length > 0) {
                    dataArray.planned_date = moment(dataArray.planned, 'DD.MM.YYYY HH:mm').format('DD.MM.YYYY');
                    dataArray.planned_time = moment(dataArray.planned, 'DD.MM.YYYY HH:mm').format('HH:mm');
                }

                this.task = dataArray;
                if (this.uploadFileList && this.uploadFileList.length === 0 && this.task.files.length) {
                    this.uploadFileList = [...this.task.files];
                }
            } catch (error) {
                if (error.response.status === 403) {
                    console.log(error.response.data.error);
                    this.loading = false;
                    this.actionAfterSaveError();
                }
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        prepareText(text) {
            return formatText(text);
        },
        getCommentDate(date) {
            if (date === this.today) {
                return 'Сегодня';
            }
            if (date === this.yesterday) {
                return 'Вчера';
            }
            return moment(date).format('D MMMM');
        }
    },
    beforeMount() {
        if (this.entityType && this.entityId) {
            this.task.related_entity_type = this.entityType;
            this.task.related_entity_id = this.entityId;
        }
        if (this.isNew) {
            this.task.status_id = 1;
            this.task.created_user_name = this.$store.state.auth.name;
            this.loading = false;
        } else {
            this.getTask();
        }
    },
    watch: {
        id(value) {
            this.loading = true;
            this.getTask();
        }
    }
};
</script>
